export enum eInternalTransferProcessingStatus {
  SENT = 'SENT',
  UPLOADED = 'UPLOADED',
}

export const prettyProcessingStatus: Record<eInternalTransferProcessingStatus, String> = {
  SENT: 'Sent',
  UPLOADED: 'Uploaded',
};
